// <s-clamp>: shows as many whole lines of [data-clamp-text] as fit in the space the layout gives it.
// [data-clamp-toggle] (Read More) opens the full text in a dialog via Invoker Commands; it is hidden
// when nothing is cut off. Below the desktop layout (no absolute frame) it falls back to data-min-lines.
class SClamp extends HTMLElement {
  #ro;
  #ac;

  connectedCallback() {
    this.text = this.querySelector('[data-clamp-text]');
    this.frame = this.querySelector('[data-clamp-frame]');
    this.button = this.querySelector('[data-clamp-toggle]');
    if (!this.text || !this.button) return;
    this.#ac = new AbortController();
    // Older browsers ignore button commands, so open and close the dialog with plain clicks there.
    if (!('commandForElement' in HTMLButtonElement.prototype)) {
      const id = this.button.getAttribute('commandfor');
      const dialog = id && document.getElementById(id);
      if (dialog) {
        this.button.addEventListener('click', () => dialog.showModal(), { signal: this.#ac.signal });
        dialog.querySelectorAll('[command="close"]').forEach((close) => {
          close.addEventListener('click', () => dialog.close(), { signal: this.#ac.signal });
        });
      }
    }
    this.#ro = new ResizeObserver(() => this.#fit());
    this.#ro.observe(this);
    this.#fit();
  }

  disconnectedCallback() {
    this.#ro?.disconnect();
    this.#ac?.abort();
  }

  #fit() {
    const style = getComputedStyle(this.text);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.5;
    const mobileLines = this.dataset.minLinesMobile && matchMedia('(max-width: 47.99rem)').matches ? this.dataset.minLinesMobile : null;
    let lines = Number(mobileLines || this.dataset.minLines || 6);
    if (this.frame && getComputedStyle(this.frame).position === 'absolute') {
      this.button.hidden = false;
      const available = this.frame.clientHeight - this.button.offsetHeight - 8;
      lines = Math.max(3, Math.floor(available / lineHeight));
    }
    this.text.style.webkitLineClamp = String(lines);
    this.text.style.lineClamp = String(lines);
    this.button.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
  }
}

if (!customElements.get('s-clamp')) customElements.define('s-clamp', SClamp);
